export const ESTADO = Object.freeze({
  BORRADOR: "BORRADOR",
  RESERVADO: "RESERVADO",
  ANULADO: "ANULADO",
  GENERADO: "GENERADO",
  CERRADO: "CERRADO"
})